/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type IssuingVelocityLimitError = {
  amount?: string | undefined;
  interval?: string | undefined;
};

/** @internal */
export const IssuingVelocityLimitError$inboundSchema: z.ZodType<
  IssuingVelocityLimitError,
  z.ZodTypeDef,
  unknown
> = z.object({
  amount: z.string().optional(),
  interval: z.string().optional(),
});
/** @internal */
export type IssuingVelocityLimitError$Outbound = {
  amount?: string | undefined;
  interval?: string | undefined;
};

/** @internal */
export const IssuingVelocityLimitError$outboundSchema: z.ZodType<
  IssuingVelocityLimitError$Outbound,
  z.ZodTypeDef,
  IssuingVelocityLimitError
> = z.object({
  amount: z.string().optional(),
  interval: z.string().optional(),
});

export function issuingVelocityLimitErrorToJSON(
  issuingVelocityLimitError: IssuingVelocityLimitError,
): string {
  return JSON.stringify(
    IssuingVelocityLimitError$outboundSchema.parse(issuingVelocityLimitError),
  );
}
export function issuingVelocityLimitErrorFromJSON(
  jsonString: string,
): SafeParseResult<IssuingVelocityLimitError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IssuingVelocityLimitError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IssuingVelocityLimitError' from JSON`,
  );
}
